import { css } from '@inter-ikea-kompis/web-component';
export default class AssemblyServicesStatusButtonStyle {
    static getStyle(options) {
        const { color } = options.theme;
        // Using small as breakpoint since fontStyle is the same for all of theme
        const { bodyMedium } = options.theme.breakpoint.small.fontStyle;
        return css `
			:host {
				display: block;
			}

			button {
				outline: none; /* Not to show default focus outline before Skapa focus outline */
			}

			span {
				line-height: ${bodyMedium.lineHeight / 16}rem;
				font-size: ${bodyMedium.size / 16}rem;
				color: ${color.neutral.grey700};
			}

			.buttonAsLinkResets {
				align-items: normal;
				background-color: rgba(0, 0, 0, 0);
				border-style: none;
				box-sizing: content-box;
				cursor: pointer;
				display: inline;
				font: inherit;
				padding: 0;
				perspective-origin: 0 0;
				text-align: start;
				text-decoration: underline;
				transform-origin: 0 0;
				width: auto;
				-moz-appearance: none;
				-webkit-logical-height: 1em;
				-webkit-logical-width: auto;
			}

			.buttonAsLinkStyling {
				color: ${color.neutral.grey700};
				height: fit-content;
			}

			skapa-status.status-hidden {
				--size: 0;
				--skapa-status-inner-margin: 0;
			}
		`;
    }
}
//# sourceMappingURL=AssemblyServicesStatusButtonStyle.js.map